/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountingFormulaValidationResponse
 */
export interface AccountingFormulaValidationResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof AccountingFormulaValidationResponse
     */
    accounts: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccountingFormulaValidationResponse
     */
    positions: Array<string>;
}

/**
 * Check if a given object implements the AccountingFormulaValidationResponse interface.
 */
export function instanceOfAccountingFormulaValidationResponse(value: object): value is AccountingFormulaValidationResponse {
    if (!('accounts' in value) || value['accounts'] === undefined) return false;
    if (!('positions' in value) || value['positions'] === undefined) return false;
    return true;
}

export function AccountingFormulaValidationResponseFromJSON(json: any): AccountingFormulaValidationResponse {
    return AccountingFormulaValidationResponseFromJSONTyped(json, false);
}

export function AccountingFormulaValidationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountingFormulaValidationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'accounts': json['accounts'],
        'positions': json['positions'],
    };
}

export function AccountingFormulaValidationResponseToJSON(json: any): AccountingFormulaValidationResponse {
    return AccountingFormulaValidationResponseToJSONTyped(json, false);
}

export function AccountingFormulaValidationResponseToJSONTyped(value?: AccountingFormulaValidationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accounts': value['accounts'],
        'positions': value['positions'],
    };
}

